import { render, staticRenderFns } from "./TaxPlanningLayout.vue?vue&type=template&id=4f4bf8c9&"
import script from "./TaxPlanningLayout.vue?vue&type=script&lang=js&"
export * from "./TaxPlanningLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports